import { Brands } from "@mojo/types"
import React from "react"

type BrandContextProps = {
  brand: Brands
}

export const context = React.createContext({} as BrandContextProps)
